import type { ReactNode } from 'react';

import { Button } from '@/components/ui/button';

import { IntegrationCard } from './IntegrationCard';

export interface DefaultActionCallbacks {
  onConnect?: () => void;
  onManage?: () => void;
  onDisconnect?: () => void;
}

export function renderDefaultActions(
  connected: boolean,
  callbacks: DefaultActionCallbacks,
  readOnly?: boolean
): ReactNode {
  if (connected) {
    if (!callbacks.onManage && !callbacks.onDisconnect) return null;
    return (
      <IntegrationCard.Actions>
        {callbacks.onManage && (
          <Button
            variant="outline"
            size="sm"
            onClick={callbacks.onManage}
            disabled={readOnly}
          >
            Manage
          </Button>
        )}
        {callbacks.onDisconnect && (
          <Button
            variant="ghost"
            size="sm"
            onClick={callbacks.onDisconnect}
            disabled={readOnly}
          >
            Disconnect
          </Button>
        )}
      </IntegrationCard.Actions>
    );
  }

  if (!callbacks.onConnect) return null;

  return (
    <IntegrationCard.Actions>
      <Button
        variant="default"
        size="sm"
        onClick={callbacks.onConnect}
        disabled={readOnly}
      >
        Connect
      </Button>
    </IntegrationCard.Actions>
  );
}
